import script from "./BaseListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseListCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseListCard.vue?vue&type=style&index=0&id=eed72fd0&lang=scss"

const __exports__ = script;

export default __exports__